export default __webpack_public_path__ + "static/media/ic_menu_employee.82fc84a8.svg";